import React from 'react';
import ResetPasswordContentPage from './components/reset-password-content.page';

const ResetPasswordPage = (props: any) => {

  return (
      <ResetPasswordContentPage />
  );
};

export default ResetPasswordPage;
